import { connect } from 'react-redux';
import ProductDetails from 'brastrap/promotional/product-details/ProductDetails';
import {
  selectTab,
  closeMessages,
  setSizeGridContainerWidth,
  getColoursNotInStock,
} from 'shared/actions/product';
import { toggleQuiz, resetAllChanges } from 'shared/actions/size-quiz';
import { addToBagAndView, selectSkuAndCloseModal } from '../actions/product';
import { selectSku } from '../../../actions/product';
import { openLayer, closeLayer } from '../../../actions/layer';
import { saveItem } from '../../../actions/saved-items';
import { addMessage, clearAllMessages } from '../../../actions/messages';

const modalId = 'field-brasize.modal';

const isAdded = (product, bag) =>
  product.selectedSku != null &&
  bag.items != null &&
  bag.items.some(item => item.skuCode === product.selectedSku.skuCode);

const mapStateToProps = state => {
  const product = state.product.styleColour;
  const {
    data: { sizes },
  } = product;
  const isSizeValue = !!(sizes && sizes.value && sizes.value === 'size');
  return {
    locale: state.app.locale.selected,
    currency: state.app.config.currency,
    product: product.data,
    quantity: state.product.quantity,
    selectedSku: product.selectedSku,
    showBraSelect: state.product.showBraSelect,
    tabs: product.tabs,
    errorMessage: state.bag.errorMessage,
    confirmationMessage: state.bag.confirmationMessage,
    displayQuiz: state.sizeQuiz.displayQuiz,
    modalId,
    isOpen: state.layer.target === modalId && state.layer.isVisible,
    isMobile: state.browser.deviceIs.mobile,
    fetchingSku: state.bag.fetchingSku,
    isAdded: isAdded(product, state.bag),
    sizeGridContainerWidth: state.product.sizeGridContainerWidth,
    savedItemsMap: state.savedItems.itemMap,
    config: state.app.config,
    showSizePicker: state.browser.deviceIs.mobile || isSizeValue,
    showSizeGrid: !state.browser.deviceIs.mobile && !isSizeValue,
    showStockFinder: state.stockFinder.enabled,
    customerDetails: state.auth.user || null,
    socialMediaChannels: state.app.config.socialMediaPixels,
    enableSizeGrid: state.app.config.sizeGrid.enabled,
    coloursNotInStock: state.product.coloursNotInStock,
  };
};

const mapDispatchToProps = dispatch => ({
  dispatch,
  onAddToCart: (styleColourCode, quantity, error) => {
    if (!error) {
      dispatch(addToBagAndView(styleColourCode, quantity));
    } else {
      dispatch(clearAllMessages());
      dispatch(addMessage(error, 'productDetails', true));
    }
  },
  onProductSelect: skuCode => {
    dispatch(clearAllMessages());
    dispatch(selectSkuAndCloseModal(skuCode));
  },
  onSizeGridProductSelect: skuCode => {
    dispatch(clearAllMessages());
    dispatch(selectSku(skuCode));
  },
  onTabSelect: tab => dispatch(selectTab(tab)),
  onCloseMessages: () => dispatch(closeMessages()),
  onModalOpen: target => dispatch(openLayer(target)),
  onModalClose: () => dispatch(closeLayer()),
  onContainerMeasure: width => dispatch(setSizeGridContainerWidth(width)),
  onSaveItemPress: item => dispatch(saveItem(item)),
  resetAllChanges: () => dispatch(resetAllChanges()),
  toggleQuiz: payload => dispatch(toggleQuiz(payload)),
  getColoursNotInStock: (styleCode, size) =>
    dispatch(getColoursNotInStock(styleCode, size)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductDetails);
